import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: $theme.sizing.scale700,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: $theme.sizing.scale600
}))

export const SearchContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: $theme.sizing.scale300
}))

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingSmall,
    margin: 'auto'
}))

export const Subtitle = styled<'h1', { $big?: boolean }>('h1', ({ $theme, $big = false }) => ({
    // if big
    ...($big && $theme.typography.LabelLarge),
    ...(!$big && $theme.typography.LabelMedium),
    margin: 0,
    textAlign: 'left',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    gap: $theme.sizing.scale200
}))

export const SpinnerContainer = styled('div', () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
}))

export const ToggleIcon = styled('i', ({ $theme }) => ({
    color: '#fff',
    fontSize: '1.6rem'
}))

export const ToggleText = styled('span', ({ $theme }) => ({
    color: '#fff',
    ...$theme.typography.LabelSmall,
    fontWeight: 700
}))

export const CitiesContainer = styled('div', ({ $theme }) => ({
    width: '100%',
    padding: $theme.sizing.scale400
}))
